import { Address, Company, ContactPerson } from "../../setups/types/setupTypes";

export type EmployeeArgs = {
  skip?: number;
  take?: number;
  searchText?: string;
  status?: EmployeeStatus;
  /** When set (non-empty), API applies status $in; overrides single `status`. */
  statuses?: EmployeeStatus[];
  nationality?: Nationalities;
  appliedCountry?: CountriesList;
  region?: string;
  brokerName?: string;
  maritalStatus?: MaritalStatus;
  religion?: ReligionTypes;
  profession?: ProfessionalTypes;
  arabic?: LanguageExperience;
  amharic?: LanguageExperience;
  english?: LanguageExperience;
  ageStart?: number;
  ageEnd?: number;
  experienceYears?: number;
  refreshList?: string;
  lastUpdated?: Date;
  link?: string;
  agencyId?: string;
  agentId?: string;
  cocCompleted?: boolean;
  medicalStatus?: MedicalStatus;
  biometricsCompleted?: boolean;
  visaIssued?: boolean;
  labourIssued?: boolean;
  flightBooked?: boolean;
  contractedPrep?: boolean;
  musanedHeld?: boolean;
  embassyPrep?: boolean;
  lmisPrep?: boolean;
  followUpType?: BookingFollowUpType;
  followUpStatus?: BookingFollowUpStatus;
  /** Calling page: `true` returns only the calling pool; omitted excludes it. */
  calling?: boolean;
};

export type ShareByEmail = {
  email?: string;
  link?: string;
};

export type VisaArgs = {
  skip?: number;
  take?: number;
  searchText?: string;
  refreshList?: string;
  lastUpdated?: Date;
};
export type EmployeesWithCount = {
  totalCount: number;
  employees: Employee[];
  header?: Company;
};
export type NotificationArgs = {
  skip?: number;
  take?: number;
  status?: NotificationStatus;
  priority?: NotificationPriority;
  employeeId?: string;
  audience?: NotificationAudience;
  excludeMessages?: string[];
};
export type NotificationsWithCount = {
  totalCount: number;
  notifications: Notification[];
};
export type VisasWithCount = {
  totalCount: number;
  visas: Visa[];
};

export type DelResult = {
  affectedRows?: string;
};

export enum Sex {
  male = "male",
  female = "female",
}
export enum NotificationStatus {
  new = "new",
  read = "read",
  archived = "archived",
}
export enum NotificationAudience {
  records = "records",
  pipeline = "pipeline",
  wall = "wall",
}
export enum NotificationPriority {
  low = "low",
  medium = "medium",
  high = "high",
  sever = "sever",
}
export enum Nationalities {
  all = "all",
  ethiopian = "ethiopian",
  kenyan = "kenyan",
  ugandan = "ugandan",
  filipino = "filipino",
  sudanese = "sudanese",
  // yemeni = "yemeni",
  // somali = "somali",
  // eritrean = "eritrean",
  // afghan = "afghan",
  // albanian = "albanian",
  // algerian = "algerian",
  // american = "american",
  // andorran = "andorran",
  // angolan = "angolan",
  // antiguans = "antiguans",
  // argentinean = "argentinean",
  // armenian = "armenian",
  // australian = "australian",
  // austrian = "austrian",
  // azerbaijani = "azerbaijani",
  // bahamian = "bahamian",
  // bahraini = "bahraini",
  // bangladeshi = "bangladeshi",
  // barbadian = "barbadian",
  // barbudans = "barbudans",
  // batswana = "batswana",
  // belarusian = "belarusian",
  // belgian = "belgian",
  // belizean = "belizean",
  // beninese = "beninese",
  // bhutanese = "bhutanese",
  // bolivian = "bolivian",
  // bosnian = "bosnian",
  // brazilian = "brazilian",
  // british = "british",
  // bruneian = "bruneian",
  // bulgarian = "bulgarian",
  // burkinabe = "burkinabe",
  // burmese = "burmese",
  // burundian = "burundian",
  // cambodian = "cambodian",
  // cameroonian = "cameroonian",
  // canadian = "canadian",
  // capeVerdean = "capeVerdean",
  // centralAfrican = "centralAfrican",
  // chadian = "chadian",
  // chilean = "chilean",
  // chinese = "chinese",
  // colombian = "colombian",
  // comoran = "comoran",
  // congolese = "congolese",
  // costaRican = "costaRican",
  // croatian = "croatian",
  // cuban = "cuban",
  // cypriot = "cypriot",
  // czech = "czech",
  // danish = "danish",
  // djibouti = "djibouti",
  // dominican = "dominican",
  // dutch = "dutch",
  // eastTimorese = "eastTimorese",
  // ecuadorean = "ecuadorean",
  // egyptian = "egyptian",
  // emirian = "emirian",
  // equatorialGuinean = "equatorialGuinean",
  // estonian = "estonian",
  // fijian = "fijian",
  // finnish = "finnish",
  // french = "french",
  // gabonese = "gabonese",
  // gambian = "gambian",
  // georgian = "georgian",
  // german = "german",
  // ghanaian = "ghanaian",
  // greek = "greek",
  // grenadian = "grenadian",
  // guatemalan = "guatemalan",
  // guineaBissauan = "guineaBissauan",
  // guinean = "guinean",
  // guyanese = "guyanese",
  // haitian = "haitian",
  // herzegovinian = "herzegovinian",
  // honduran = "honduran",
  // hungarian = "hungarian",
  // icelander = "icelander",
  // indian = "indian",
  // indonesian = "indonesian",
  // iranian = "iranian",
  // iraqi = "iraqi",
  // irish = "irish",
  // italian = "italian",
  // ivorian = "ivorian",
  // jamaican = "jamaican",
  // japanese = "japanese",
  // jordanian = "jordanian",
  // kazakhstani = "kazakhstani",
  // kittianAndNevisian = "kittianAndNevisian",
  // kuwaiti = "kuwaiti",
  // kyrgyz = "kyrgyz",
  // laotian = "laotian",
  // latvian = "latvian",
  // lebanese = "lebanese",
  // liberian = "liberian",
  // libyan = "libyan",
  // liechtensteiner = "liechtensteiner",
  // lithuanian = "lithuanian",
  // luxembourger = "luxembourger",
  // macedonian = "macedonian",
  // malagasy = "malagasy",
  // malawian = "malawian",
  // malaysian = "malaysian",
  // maldivan = "maldivan",
  // malian = "malian",
  // maltese = "maltese",
  // marshallese = "marshallese",
  // mauritanian = "mauritanian",
  // mauritian = "mauritian",
  // mexican = "mexican",
  // micronesian = "micronesian",
  // moldovan = "moldovan",
  // monacan = "monacan",
  // mongolian = "mongolian",
  // moroccan = "moroccan",
  // mosotho = "mosotho",
  // motswana = "motswana",
  // mozambican = "mozambican",
  // namibian = "namibian",
  // nauruan = "nauruan",
  // nepalese = "nepalese",
  // newZealander = "newZealander",
  // niVanuatu = "niVanuatu",
  // nicaraguan = "nicaraguan",
  // nigerien = "nigerien",
  // northKorean = "northKorean",
  // northernIrish = "northernIrish",
  // norwegian = "norwegian",
  // omani = "omani",
  // pakistani = "pakistani",
  // palauan = "palauan",
  // palestinian = "palestinian",
  // panamanian = "panamanian",
  // papuaNewGuinean = "papuaNewGuinean",
  // paraguayan = "paraguayan",
  // peruvian = "peruvian",
  // polish = "polish",
  // portuguese = "portuguese",
  // qatari = "qatari",
  // romanian = "romanian",
  // russian = "russian",
  // rwandan = "rwandan",
  // saintLucian = "saintLucian",
  // salvadoran = "salvadoran",
  // samoan = "samoan",
  // sanMarinese = "sanMarinese",
  // saoTomean = "saoTomean",
  // saudi = "saudi",
  // scottish = "scottish",
  // senegalese = "senegalese",
  // serbian = "serbian",
  // seychellois = "seychellois",
  // sierraLeonean = "sierraLeonean",
  // singaporean = "singaporean",
  // slovakian = "slovakian",
  // slovenian = "slovenian",
  // solomonIslander = "solomonIslander",
  // southAfrican = "southAfrican",
  // southKorean = "southKorean",
  // spanish = "southKorean",
  // sriLankan = "sriLankan",
  // surinamer = "surinamer",
  // swazi = "swazi",
  // swedish = "swedish",
  // swiss = "swiss",
  // syrian = "syrian",
  // taiwanese = "taiwanese",
  // tajik = "tajik",
  // tanzanian = "tanzanian",
  // thai = "thai",
  // togolese = "togolese",
  // tongan = "tongan",
  // trinidadianorTobagonian = "trinidadianorTobagonian",
  // tunisian = "tunisian",
  // turkish = "turkish",
  // tuvaluan = "tuvaluan",
  // ukrainian = "ukrainian",
  // uruguayan = "uruguayan",
  // uzbekistani = "uzbekistani",
  // venezuelan = "venezuelan",
  // vietnamese = "vietnamese",
  // welsh = "welsh",
  // zambian = "zambian",
  // zimbabwean = "zimbabwean",
}
export enum CurrencyTypes {
  saudi_riyal = "saudi_riyal",
  qatar_riyal = "qatar_riyal",
  kuwait_dinar = "kuwait_dinar",
  emirate_dirham = "emirate_dirham",
  jordan_dinar = "jordan_dinar",
  lebanon_lire = "lebanon_lire",
  ethiopia_birr = "ethiopia_birr",
}
export type Education = {
  arabicLanguage?: LanguageExperience;
  amharicLanguage?: LanguageExperience;
  cooking?: CookingExperience;
  englishLanguage?: LanguageExperience;
  educationLevel?: EducationLevel;
  fieldOfStudy?: string;
  yearCompleted?: string;
  skills?: Skills[];
  educationQG?: string;
  remarks?: string;
};

export type EmbassyProcess = {
  enjazNumber?: string;
  submissionDate?: Date;
  stamped?: boolean;
  stampedDate?: Date;
  cancelled?: boolean;
  canceledDate?: Date;
  remarks?: string;
};

export type FlightProcess = {
  flightDateTime?: Date;
  ticketNumber?: string;
  flightNumber?: string;
  ticketAmount?: number;
  ticketCity?: string;
  departed?: boolean;
  arrivedDateTime?: Date;
  remarks?: string;
};

export type AdditionalData = {
  nationality?: Nationalities;
  pastNationality?: Nationalities;
  maritalStatus?: MaritalStatus;
  religion?: ReligionTypes;
  appliedProfession?: ProfessionalTypes;
  appliedCountry?: CountriesList;
  contractPeriod?: ExperienceYears;
  complexion?: Complexion;
  salary?: number;
  currency?: CurrencyTypes;
  numberOfChildren?: number;
  height?: string;
  weight?: string;
  documentReceivedDate?: Date;
  notes?: string;
  fullNameAmharic?: string;
  lmisId?: string;
  lmisPassword?: string;
  labourId?: string;
  musanedHeld?: boolean;
  discontinued?: boolean;
  discontinuedDate?: Date;
  discontinuedRemark?: string;
  afterFlightStatus?: AfterFlightStatus;
  afterFlightStatusDate?: Date;
  afterFlightStatusRemark?: string;
};

export enum LanguageExperience {
  poor = "poor",
  fair = "fair",
  good = "good",
  fluent = "fluent",
}

export enum CookingExperience {
  poor = "poor",
  fair = "fair",
  good = "good",
  excellent = "excellent",
}
export enum LanguageExperienceFilter {
  all = "all",
  poor = "poor",
  fair = "fair",
  good = "good",
  fluent = "fluent",
}

export enum EducationLevel {
  grade_eight_complete = "grade_eight_complete",
  secondary_complete = "secondary_complete",
  vocational_complete = "vocational_complete",
  college_complete = "college_complete",
  post_graduate = "post_graduate",
  other_education = "other_education",
}

export type Visa = {
  _id?: string;
  visaNumber: string;
  fullName: string;
  fullNameAmharic?: string;
  cityAmharic?: string;
  passportNumber?: string;
  sponsorBirthDate?: string;
  visaQty?: number;
  contractNumber?: string;
  fileNumber?: string;
  bankNumber?: string;
  visaDate?: Date;
  visaDateArabic?: string;
  wekalaNumber?: string;
  wekalaDate?: string;
  profession?: ProfessionalTypes;
  salary?: number;
  currency?: CurrencyTypes;
  religion?: ReligionTypes;
  ageCategory?: AgeCategory;
  complexion?: Complexion;
  visaType?: VisaTypes;
  status?: VisaStatus;
  firstTime?: Boolean;
  goodLooking?: Boolean;
  writeRead?: Boolean;
  remarks?: string;
  address?: Address;
  owner?: Company;
  prospects?: [Company];
  assignedEmployees?: [string];
  createdBy?: string;
  modifiedBy?: string;
  createdAt?: Date;
  modifiedAt?: Date;
};

export enum ProfessionalTypes {
  housemaid = "housemaid",
  house_worker = "house_worker",
  driver = "driver",
  baby_sitter = "baby_sitter",
  nanny = "nanny",
  cooker = "cooker",
  nurse = "nurse",
  farm_worker = "farm_worker",
  other_profession = "other_profession",
}
export enum ProfessionalTypesFilter {
  all = "all",
  housemaid = "housemaid",
  house_worker = "house_worker",
  driver = "driver",
  baby_sitter = "baby_sitter",
  nanny = "nanny",
  cooker = "cooker",
  nurse = "nurse",
  farm_worker = "farm_worker",
  other_profession = "other_profession",
}

export enum ReligionTypes {
  muslim = "muslim",
  non_muslim = "non_muslim",
  christian = "christian",
  other_religion = "other_religion",
}
export enum ReligionTypesFilter {
  all = "all",
  muslim = "muslim",
  non_muslim = "non_muslim",
  christian = "christian",
  other_religion = "other_religion",
}

export enum AgeCategory {
  bet2125 = "bet2125",
  bet2630 = "bet2630",
  bet3135 = "bet3135",
  bet3640 = "bet3640",
  bet4145 = "bet4145",
}
export enum AgeGap {
  all = "all",
  age21 = "21",
  age25 = "25",
  age30 = "30",
  age35 = "35",
  age40 = "40",
  age45 = "45",
  age50 = "50",
}

export enum Complexion {
  brown = "brown",
  black = "black",
  blue = "blue",
  acceptable = "acceptable",
}

export type WorkExperience = {
  _id?: string;
  country?: CountriesList;
  profession?: ProfessionalTypes;
  years?: ExperienceYears;
};

export enum NotificationMessageTypes {
  first_timer_added = "first_timer_added",
  experienced_added = "experienced_added",
  //under_process = "under_process",
  ready_to_go = "ready_to_go",
  selected = "selected",
  contracted = "contracted",
  deSelected = "deSelected",
  medical_completed = "medical_completed",
  medical_failed = "medical_failed",
  visa_issued = "visa_issued",
  labour_issued = "labour_issued",
  flight_booked = "flight_booked",
  departed = "departed",
  lost = "lost",
  returned = "returned",
  has_complain = "has_complain",
  contract_completed = "contract_completed",
  cancelled_processing = "cancelled_processing",
  request_deletion = "request_deletion",
  deleted = "deleted",
  updated = "updated",
  wall_mentioned = "wall_mentioned",
  wall_commented = "wall_commented",
  medical_expiring = "medical_expiring",
  passport_expiring = "passport_expiring",
  labour_expiring = "labour_expiring",
  insurance_expiring = "insurance_expiring",
  selection_due = "selection_due",
}

export enum Skills {
  driving = "driving",
  baby_sitting = "baby_sitting",
  children_care = "children_care",
  tutoring_children = "tutoring_children",
  washing_ironing_clothes = "washing_ironing_clothes",
  dusting_cleaning = "dusting_cleaning",
  washing_dishes = "washing_dishes",
  cooking = "cooking",
  arabic_cooking = "arabic_cooking",
  sewing = "sewing",
  computer = "computer",
  decorating = "decorating",
  other_skills = "other_skills",
}
export enum RequiredDocuments {
  photo = "photo",
  passport = "passport",
  medical = "medical",
  id_card = "id_card",
  emergency_person_id_card = "emergency_person_id_card",
  grade_eight_certificate = "grade_eight_certificate",
  coc_certificate = "coc_certificate",
  insurance = "insurance",
  finger_print = "finger_print",
  emergency_person_photo = "emergency_person_photo",
  abroad_job_agreement = "abroad_job_agreement",
  trip_orientation = "trip_orientation",
}
export enum GulfCountries {
  saudi_arabia = "saudi_arabia",
  uae = "uae",
  kuwait = "kuwait",
  qatar = "qatar",
  jordan = "jordan",
  lebanon = "lebanon",
  bahrain = "bahrain",
  oman = "oman",
}
export enum CountriesList {
  saudi_arabia = "saudi_arabia",
  uae = "uae",
  kuwait = "kuwait",
  qatar = "qatar",
  lebanon = "lebanon",
  bahrain = "bahrain",
  jordan = "jordan",
  yemen = "yemen",
  syria = "syria",
  oman = "oman",
  ethiopia = "ethiopia",
  kenya = "kenya",
  sudan = "sudan",
  somalia = "somalia",
  eritrea = "eritrea",
  egypt = "egypt",
  uganda = "uganda",
  philippines = "philippines",
  iran = "iran",
  iraq = "iraq",
  morocco = "morocco",
  algeria = "algeria",
  tunisia = "tunisia",
  libya = "libya",
  mauritania = "mauritania",
  mali = "mali",
  niger = "niger",
  chad = "chad",
  senegal = "senegal",
  gambia = "gambia",
  guinea = "guinea",
  guinea_bissau = "guinea_bissau",
  sierra_leone = "sierra_leone",
  liberia = "liberia",
  cote_divoire = "cote_divoire",
  ghana = "ghana",
  burkina_faso = "burkina_faso",
  togo = "togo",
  benin = "benin",
  nigeria = "nigeria",
  cameroon = "cameroon",
  central_african_republic = "central_african_republic",
  equatorial_guinea = "equatorial_guinea",
  gabon = "gabon",
  congo = "congo",
  democratic_republic_of_the_congo = "democratic_republic_of_the_congo",
  rwanda = "rwanda",
  burundi = "burundi",
  tanzania = "tanzania",
  angola = "angola",
  zambia = "zambia",
  malawi = "malawi",
  mozambique = "mozambique",
  madagascar = "madagascar",
  zimbabwe = "zimbabwe",
  botswana = "botswana",
  namibia = "namibia",
  south_africa = "south_africa",
  lesotho = "lesotho",
  eswatini = "eswatini",
  comoros = "comoros",
  seychelles = "seychelles",
  mauritius = "mauritius",
  cape_verde = "cape_verde",
  south_sudan = "south_sudan",
  greece = "greece",
  cyprus = "cyprus",
  turkey = "turkey",
  georgia = "georgia",
  armenia = "armenia",
  azerbaijan = "azerbaijan",
  russia = "russia",
  ukraine = "ukraine",
  belarus = "belarus",
  moldova = "moldova",
  romania = "romania",
  bulgaria = "bulgaria",
  serbia = "serbia",
  montenegro = "montenegro",
  kosovo = "kosovo",
  albania = "albania",
  north_macedonia = "north_macedonia",
  bosnia_and_herzegovina = "bosnia_and_herzegovina",
  croatia = "croatia",
  slovenia = "slovenia",
  hungary = "hungary",
  slovakia = "slovakia",
  czechia = "czechia",
  poland = "poland",
  germany = "germany",
  austria = "austria",
  switzerland = "switzerland",
  liechtenstein = "liechtenstein",
  italy = "italy",
  san_marino = "san_marino",
  vatican_city = "vatican_city",
  malta = "malta",
  spain = "spain",
  portugal = "portugal",
  andorra = "andorra",
  france = "france",
  monaco = "monaco",
  belgium = "belgium",
  netherlands = "netherlands",
  luxembourg = "luxembourg",
  united_kingdom = "united_kingdom",
  ireland = "ireland",
  iceland = "iceland",
  denmark = "denmark",
  norway = "norway",
  sweden = "sweden",
  finland = "finland",
  estonia = "estonia",
  latvia = "latvia",
  lithuania = "lithuania",
  greenland = "greenland",
  canada = "canada",
  united_states = "united_states",
  mexico = "mexico",
  guatemala = "guatemala",
  belize = "belize",
  honduras = "honduras",
  el_salvador = "el_salvador",
  nicaragua = "nicaragua",
  costa_rica = "costa_rica",
  panama = "panama",
  cuba = "cuba",
  jamaica = "jamaica",
  haiti = "haiti",
  dominican_republic = "dominican_republic",
  bahamas = "bahamas",
  barbados = "barbados",
  saint_lucia = "saint_lucia",
  saint_vincent_and_the_grenadines = "saint_vincent_and_the_grenadines",
  grenada = "grenada",
  trinidad_and_tobago = "trinidad_and_tobago",
  antigua_and_barbuda = "antigua_and_barbuda",
  saint_kitts_and_nevis = "saint_kitts_and_nevis",
  colombia = "colombia",
  venezuela = "venezuela",
  guyana = "guyana",
  suriname = "suriname",
  ecuador = "ecuador",
  peru = "peru",
  bolivia = "bolivia",
  paraguay = "paraguay",
  chile = "chile",
  argentina = "argentina",
  uruguay = "uruguay",
  brazil = "brazil",
  australia = "australia",
  new_zealand = "new_zealand",
  papua_new_guinea = "papua_new_guinea",
  fiji = "fiji",
  solomon_islands = "solomon_islands",
  vanuatu = "vanuatu",
  samoa = "samoa",
  tonga = "tonga",
  tuvalu = "tuvalu",
  kiribati = "kiribati",
  marshall_islands = "marshall_islands",
  micronesia = "micronesia",
  palau = "palau",
  nauru = "nauru",
  timor_leste = "timor_leste",
  mongolia = "mongolia",
  china = "china",
  japan = "japan",
  south_korea = "south_korea",
  north_korea = "north_korea",
  taiwan = "taiwan",
  hong_kong = "hong_kong",
  macau = "macau",
  vietnam = "vietnam",
  laos = "laos",
  cambodia = "cambodia",
  thailand = "thailand",
  myanmar = "myanmar",
  malaysia = "malaysia",
  singapore = "singapore",
  brunei = "brunei",
  indonesia = "indonesia",
  east_timor = "east_timor",
  india = "india",
  pakistan = "pakistan",
  bangladesh = "bangladesh",
  nepal = "nepal",
  bhutan = "bhutan",
  sri_lanka = "sri_lanka",
  maldives = "maldives",
  afghanistan = "afghanistan",

  israel = "israel",
  palestine = "palestine",

  kazakhstan = "kazakhstan",
  uzbekistan = "uzbekistan",
  turkmenistan = "turkmenistan",
  kyrgyzstan = "kyrgyzstan",
  tajikistan = "tajikistan",
  saint_pierre_and_miquelon = "saint_pierre_and_miquelon",
  french_guiana = "french_guiana",
  guadeloupe = "guadeloupe",
  martinique = "martinique",
  reunion = "reunion",
  mayotte = "mayotte",
  new_caledonia = "new_caledonia",
  french_polynesia = "french_polynesia",
  wallis_and_futuna = "wallis_and_futuna",
  saint_barthelemy = "saint_barthelemy",
  saint_martin = "saint_martin",
  aruba = "aruba",
  curacao = "curacao",
  bonaire = "bonaire",
  sint_eustatius = "sint_eustatius",
  saba = "saba",
  sint_maarten = "sint_maarten",
  bermuda = "bermuda",
  cayman_islands = "cayman_islands",
  falkland_islands = "falkland_islands",
  gibraltar = "gibraltar",
  montserrat = "montserrat",
  pitcairn_islands = "pitcairn_islands",
  saint_helena = "saint_helena",
  turks_and_caicos_islands = "turks_and_caicos_islands",
  british_virgin_islands = "british_virgin_islands",
  anguilla = "anguilla",
  faroe_islands = "faroe_islands",
  aland_islands = "aland_islands",
  jersey = "jersey",
  guernsey = "guernsey",
  isle_of_man = "isle_of_man",
}

export enum ExperienceYears {
  one = "one",
  two = "two",
  three = "three",
  four = "four",
  five = "five",
  six = "six",
  seven = "seven",
  eight = "eight",
  nine = "nine",
  ten = "ten",
}
export enum ExperiencePeriods {
  all = "all",
  firstTime = "1",
  experienced = "2",
}

export enum VisaStatus {
  new = "new",
  available = "available",
  rejected = "rejected",
  employee = "employee",
  arrived = "arrived",
  processing = "processing",
  keep_ready = "keep_ready",
  visa_ready = "visa_ready",
  on_medical = "on_medical",
  on_foreign_affairs = "on_foreign_affairs",
}
export enum VisaTypes {
  work = "work",
  visit = "visit",
  transit = "transit",
  residence = "residence",
  umrah = "umrah",
  hajj = "hajj",
  diplomacy = "diplomacy",
  other = "other",
}
export type ShortLink = {
  _id?: string;
  link?: string;

  employeeIds?: string[];
  employees?: [Employee];
  expiredAt?: Date;
  company?: Company;
  header?: Company;
  headerId?: string;
};
export type ShareLink = {
  employeeIds: [string];
  companyId: string;
  headerId: string;
};

export enum EmployeeStatusEventType {
  status_change = "status_change",
  partner_selected = "partner_selected",
  partner_released = "partner_released",
  contracted = "contracted",
  pipeline_update = "pipeline_update",
  selection_expired = "selection_expired",
  follow_up_update = "follow_up_update",
  remark_added = "remark_added",
}

export type StatusDates = {
  new?: Date;
  selected?: Date;
  contracted?: Date;
  departed?: Date;
  discontinued?: Date;
  stopped?: Date;
  lost?: Date;
  returned?: Date;
  has_complain?: Date;
  contract_completed?: Date;
  other?: Date;
};

export type EmployeeStatusHistoryMetadata = {
  partnerId?: string;
  partnerName?: string;
  visaIssued?: boolean;
  labourIssued?: boolean;
  ticketBooked?: boolean;
  medicalStatus?: MedicalStatus;
  cocCompleted?: boolean;
  biometricsCompleted?: boolean;
  visaIssuedDate?: Date;
  lmisIssuedDate?: Date;
  flightDateTime?: Date;
  medicalFitDate?: Date;
  cocCompletedDate?: Date;
};

export type EmployeeStatusHistoryEntry = {
  eventType: EmployeeStatusEventType;
  status?: EmployeeStatus;
  previousStatus?: EmployeeStatus;
  effectiveDate?: Date;
  changedAt: Date;
  changedByEmail: string;
  remark?: string;
  metadata?: EmployeeStatusHistoryMetadata;
};

export type Employee = {
  _id?: string;
  givenName?: string;
  surName?: string;
  passportNumber?: string;
  sex?: Sex;
  status?: EmployeeStatus;
  currentStatusDate?: Date;
  statusDates?: StatusDates;
  statusHistory?: EmployeeStatusHistoryEntry[];
  currentStatusRemark?: string;
  placeOfBirth?: string;
  placeOfIssue?: string;
  dateOfBirth?: Date;
  passportIssueDate?: Date;
  passportExpiryDate?: Date;
  documents?: [RequiredDocuments];
  additionalData?: AdditionalData;
  address?: Address;
  contactPerson?: ContactPerson;
  education?: Education;
  embassyProcess?: EmbassyProcess;
  flight?: FlightProcess;
  workExperience?: [WorkExperience];
  facePhoto?: string;
  standPhoto?: string;
  medicalPhoto?: string;
  passportScan?: string;
  originalIdScan?: string;
  emergencyContactIdScan?: string;
  insuranceScan?: string;
  cocCertificateScan?: string;
  educationCertificateScan?: string;
  fingerPrintScan?: string;
  employmentContractScan?: string;
  workingVisaScan?: string;
  flightTicketScan?: string;
  employeeVideo?: string;
  notificationMessage?: string;

  medicalStatus?: MedicalStatus;
  medicalBookedDate?: Date;
  medicalExpiryDate?: Date;
  medicalFitDate?: Date;
  cocCompleted?: boolean;
  cocCompletedDate?: Date;
  biometricsCompleted?: boolean;
  visaIssued?: boolean;
  visaIssuedDate?: Date;
  labourIssued?: boolean;
  lmisIssuedDate?: Date;
  ticketBooked?: boolean;
  calling?: boolean;

  medicalFollowUp?: BookingFollowUp;
  tasheerFollowUp?: BookingFollowUp;
  embassyFollowUp?: BookingFollowUp;
  flightFollowUp?: BookingFollowUp;

  owner?: Company;
  partner?: Company;
  selectionDueDate?: Date;
  parentCompany?: Company;
  referenceNumber?: number;
  visa?: Visa;
  /** Mutation-only: detach visa and partner on deselect */
  clearVisa?: boolean;
  prospects?: [Company];
  createdBy?: string;
  modifiedBy?: string;
  createdAt?: Date;
  updatedAt?: Date;
};

export type UpdateEmployeeStatusInput = {
  _id: string;
  status: EmployeeStatus;
  currentStatusDate?: Date;
  currentStatusRemark?: string;
  cocCompleted?: boolean;
  medicalStatus?: MedicalStatus;
  medicalBookedDate?: Date;
  medicalExpiryDate?: Date;
  biometricsCompleted?: boolean;
  visaIssued?: boolean;
  visaIssuedDate?: Date;
  labourIssued?: boolean;
  lmisIssuedDate?: Date;
  ticketBooked?: boolean;
  flight?: FlightProcess;
};
export type AddEmployeeStatusRemarkInput = {
  _id: string;
  remark: string;
  effectiveDate?: Date;
};
export type BulkUpdateEmployeeStatusInput = {
  ids: string[];
  status: EmployeeStatus;
  currentStatusDate?: Date;
  currentStatusRemark?: string;
};
export type BulkStatusUpdateResult = {
  updated: number;
  failed: number;
  errors: string[];
};

export type UpdateBookingFollowUpInput = {
  employeeId: string;
  type: BookingFollowUpType;
  status: BookingFollowUpStatus;
  scheduledDate?: Date | string;
  remark?: string;
};

export type BulkUpdateBookingFollowUpInput = {
  ids: string[];
  type: BookingFollowUpType;
  status: BookingFollowUpStatus;
  scheduledDate?: Date | string;
  remark?: string;
};

export type BulkBookingFollowUpResult = {
  updated: number;
  failed: number;
  errors: string[];
};

export type Notification = {
  _id?: string;
  employee?: Employee;
  from?: Company;
  recipients?: Company[];
  message: string;
  priority?: NotificationPriority;
  status?: NotificationStatus;
  audience?: NotificationAudience;
  createdAt?: Date;
  fromUserEmail?: string;
  contextText?: string;
  wallPostRef?: string;
  wallPost?: { _id?: string; message?: string };
  targetUser?: { _id?: string; name?: string };
};
export enum PhotoTypes {
  Face = "Face",
  Stand = "Stand",
  Medical = "Medical",
  Passport = "Passport",
  OriginalId = "OriginalId",
  EmergencyContactId = "EmergencyContactId",
  Insurance = "Insurance",
  CocCertificate = "CocCertificate",
  EducationCertificate = "EducationCertificate",
  FingerPrint = "FingerPrint",
  EmploymentContract = "EmploymentContract",
  WorkingVisa = "WorkingVisa",
  FlightTicket = "FlightTicket",
  Header = "Header",
  Bottom = "Bottom",
  User = "User",
  Cv = "Cv",
  Video = "Video",
  Voice = "Voice",
  Attachment = "Attachment",
}
export enum MaritalStatus {
  single = "single",
  married = "married",
  divorced = "divorced",
  widow = "widow",
  separated = "separated",
}
export enum MaritalStatusFilter {
  all = "all",
  single = "single",
  married = "married",
  divorced = "divorced",
  widow = "widow",
  separated = "separated",
}
export enum AfterFlightStatus {
  on_good_condition = "on_good_condition",
  lost = "lost",
  returned = "returned",
  has_complain = "has_complain",
  contract_completed = "contract_completed",
}
export enum CompletionStatus {
  all = "all",
  completed = "completed",
  not_completed = "not_completed",
}
export enum MedicalStatus {
  not_done = "not_done",
  booked = "booked",
  completed = "completed",
  record_not_found = "record_not_found",
  expired = "expired",
  fit = "fit",
  unfit = "unfit",
}

export enum BookingFollowUpStatus {
  new = "new",
  booked_with_date = "booked_with_date",
  confirmed_by_employee = "confirmed_by_employee",
  employee_completed = "employee_completed",
  embassy_in_progress = "embassy_in_progress",
  embassy_returned = "embassy_returned",
  embassy_stamped = "embassy_stamped",
}

export enum BookingFollowUpType {
  medical = "medical",
  tasheer = "tasheer",
  embassy = "embassy",
  flight = "flight",
}

export type BookingFollowUp = {
  status?: BookingFollowUpStatus;
  scheduledDate?: Date | string;
  confirmedAt?: Date | string;
  confirmedByUserEmail?: string;
  completedAt?: Date | string;
  remark?: string;
  updatedAt?: Date | string;
};

export type FollowUpStatusCountRow = {
  status: BookingFollowUpStatus;
  count: number;
};

export type FollowUpTypeCountRow = {
  type: BookingFollowUpType;
  byStatus: FollowUpStatusCountRow[];
};

export type EmployeeDashboardStats = {
  totalCount: number;
  byStatus: { status: string; count: number }[];
  byAppliedCountry: { country: string; count: number }[];
  visaIssuedTrueCount: number;
  labourIssuedTrueCount: number;
  embassyProcessTabCount: number;
  lmisProcessTabCount: number;
  ticketingTabCount: number;
  contractedPrepTabCount: number;
  followUpCounts?: FollowUpTypeCountRow[];
};

export enum EmployeeStatus {
  all = "all",
  pending = "pending",
  new = "new",
  //under_process = "under_process",
  selected = "selected",
  contracted = "contracted",
  visa_issued = "visa_issued",
  labour_issued = "labour_issued",
  ticketing = "ticketing",
  flight_booked = "flight_booked",
  departed = "departed",
  discontinued = "discontinued",
  stopped = "stopped",
  lost = "lost",
  returned = "returned",
  has_complain = "has_complain",
  contract_completed = "contract_completed",
  other = "other",
  // medical_process = "medical_process",
  // coc_process = "coc_process",
  // on_good_condition = "on_good_condition",
}
export enum StatusFilter {
  all = "all",
  new = "new",
  selected = "selected",
  contract_process = "contract_process",
  medical_process = "medical_process",
  visa_issued = "visa_issued",
  ossc_process = "ossc_process",
  labour_issued = "labour_issued",
  discontinued = "discontinued",
  visa_canceled = "visa_canceled",
  flight_process = "flight_process",
  flight_booked = "flight_booked",
  departed = "departed",
  on_good_condition = "on_good_condition",
  lost = "lost",
  returned = "returned",
  has_complain = "has_complain",
}

export type ProcessState = {
  employeesWithCount: EmployeesWithCount;
  notificationsWithCount: NotificationsWithCount;
  popupNotificationsWithCount: NotificationsWithCount;
  visasWithCount: VisasWithCount;
  selectedEmployee: Employee;
  sharedLinks: ShortLink[];
  selectedVisa: Visa;
  selectedShortLink: ShortLink;
  shortLinkHeader: Company;
  /** When true, next tab list fetch should bypass Apollo cache (set after list-affecting mutations). */
  employeeListsStale: boolean;
  /** List fetch only (Employees/Candidates tables); avoids modal/detail ops flashing the table. */
  listLoading: "idle" | "pending";
  /** requestId of the latest fetchEmployees dispatch; older responses are ignored. */
  listRequestId: string | undefined;
  loading: "idle" | "pending";
  currentRequestId: string | undefined;
  success: any;
  error: any;
};
